import type { FieldErrors, UseFormRegister, Control } from 'react-hook-form'
import clsx from 'clsx'
import { sanitizeFieldName } from '@/utils/sanitizedLabel'
import { Controller } from 'react-hook-form'

type Props = {
	id: string
	label: string
	required: boolean
	formStyle: string
	colSpan?: string
	register: UseFormRegister<any>
	control: Control<any>
	errors: FieldErrors
	className?: string
	selectOptions?: string[]
}

export default function MultipleChoice({
	id,
	label,
	required,
	formStyle,
	colSpan = '1',
	control,
	errors,
	className,
	selectOptions = [],
}: Props) {
	const fieldName = sanitizeFieldName(label)

	return (
		<div
			className={clsx(
				'form-component',
				{
					'2': 'colSpan2',
				}[colSpan],
				className
			)}
		>
			<label className="my-2">{`${label} ${required ? '*' : ''}`}</label>

			<Controller
				name={fieldName}
				control={control}
				defaultValue={[]}
				rules={{
					required: required && `${label} is required`,
					validate: (value) => {
						if (required && (!value || value.length === 0)) {
							return `${label} is required`
						}
						return true
					},
				}}
				render={({ field }) => (
					<div className="grid grid-cols-1 gap-3">
						{selectOptions.map((option, index) => (
							<label
								key={`${id}-${index}`}
								className={clsx(
									'flex items-center gap-3 cursor-pointer px-5 h-16 rounded-lg transition-colors bg-white-frosted',
									'hover:bg-white-frosted-shade has-[:checked]:bg-white-frosted-shade',
									formStyle === 'line' ? 'border-b' : 'rounded-lg'
								)}
							>
								<input
									type="checkbox"
									id={`${id}-${index}`}
									value={option}
									data-type="multipleChoice"
									checked={field.value?.includes(option)}
									onChange={(e) => {
										const updatedValue = e.target.checked
											? [...(field.value || []), option]
											: (field.value || []).filter((item: string) => item !== option)
										field.onChange(updatedValue)
									}}
									className="w-5 h-5 cursor-pointer rounded"
								/>
								<span className="flex-1">{option}</span>
							</label>
						))}
					</div>
				)}
			/>

			{errors[fieldName] && (
				<span className="mt-1 text-red-500">{errors[fieldName]?.message?.toString()}</span>
			)}
		</div>
	)
}
